import {
	Aes256Gcm,
	CipherSuite,
	DhkemP256HkdfSha256,
	HkdfSha256,
} from "@hpke/core";

export const createHpkeSuite = () => {
	return new CipherSuite({
		kem: new DhkemP256HkdfSha256(),
		kdf: new HkdfSha256(),
		aead: new Aes256Gcm(),
	});
};
